import { defineSlotRecipe } from '@chakra-ui/react';

export const fieldSlotRecipe = defineSlotRecipe({
  className: 'chakra-field',
  slots: ['root', 'label', 'errorText', 'helperText', 'requiredIndicator'],
  base: {
    requiredIndicator: {
      color: 'red',
      lineHeight: '1',
    },
    root: {
      display: 'flex',
      width: '100%',
      position: 'relative',
      gap: '1.5',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'start',
      fontFamily: 'roboto',
      fontWeight: 'regular',
      fontSize: 'md',
      gap: '1',
      userSelect: 'none',
    },
    errorText: {
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: 'medium',
      gap: '1',
      color: 'red',
      textStyle: 'roboto',
      backgroundColor: 'red.100',
      width: 'full',
      height: '50px',
      padding: 2,
    },
    helperText: {
      color: 'neutral.300',
      fontFamily: 'roboto',
      fontSize: 'md',
    },
  },
  variants: {
    variant: {
      cockpit: {
        label: {
          color: 'neutral.300 !important',
          fontSize: 'sm',
        },
      },
    },
  },
});
